import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { entAxios } from "./entApi";
import { toast } from "sonner";
import { Loader2, Bike } from "lucide-react";

export default function EntregadorLoginPage() {
  const nav = useNavigate();
  const [f, setF] = useState({ whatsapp: "", senha: "" });
  const [loading, setLoading] = useState(false);

  const entrar = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await entAxios.post("/vaipede/entregador/login", f);
      localStorage.setItem("vaipede_entregador_token", data.token);
      localStorage.setItem("vaipede_entregador", JSON.stringify(data.entregador));
      toast.success(`Bem-vindo, ${data.entregador.nome}!`);
      nav("/vaipede/entregador/painel");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Falha no login");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-neutral-50 grid place-items-center p-4" data-testid="vaipede-ent-login">
      <div className="w-full max-w-sm">
        <div className="text-center mb-6">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-[#EA1D2C] grid place-items-center mb-3">
            <Bike className="w-8 h-8 text-white"/>
          </div>
          <h1 className="font-black text-2xl">Área do entregador</h1>
          <p className="text-sm text-neutral-500 mt-1">Entre para receber pedidos prontos</p>
        </div>
        <form onSubmit={entrar} className="bg-white rounded-2xl border border-neutral-200 p-5 space-y-3">
          <input value={f.whatsapp} onChange={e => setF({...f, whatsapp: e.target.value})} placeholder="WhatsApp (com DDD)" className="w-full px-4 py-3 rounded-xl border border-neutral-200 outline-none focus:border-[#EA1D2C]" data-testid="vaipede-ent-login-whatsapp"/>
          <input type="password" value={f.senha} onChange={e => setF({...f, senha: e.target.value})} placeholder="Senha" className="w-full px-4 py-3 rounded-xl border border-neutral-200 outline-none focus:border-[#EA1D2C]" data-testid="vaipede-ent-login-senha"/>
          <button type="submit" disabled={loading} className="w-full py-3 rounded-xl bg-[#EA1D2C] text-white font-black disabled:opacity-60 flex items-center justify-center gap-2" data-testid="vaipede-ent-login-btn">
            {loading && <Loader2 className="w-4 h-4 animate-spin"/>} Entrar
          </button>
        </form>
        <p className="text-xs text-center text-neutral-500 mt-4">
          Não tem cadastro? Peça ao administrador da loja.
        </p>
      </div>
    </div>
  );
}
